import { Injectable , EventEmitter} from '@angular/core';
import { Subscription, BehaviorSubject, Subject } from 'rxjs';
import { ValueTemplateDirective } from '@progress/kendo-angular-dropdowns';

@Injectable({
  providedIn: 'root'
})
export class UpdatefontsizeService {

   // Observable string sources
  private fontTypeSource = new Subject<any>();
  
  // Observable string streams
  currentFontSource$ = this.fontTypeSource.asObservable();

  constructor() { }    
    
  onFontButtonClick(type: string) {
    this.fontTypeSource.next(type);
  }  

}
